import { Stack, Typography } from '@mui/material'

import { Modal, Button } from '@repo/ui'

interface BuyLabelConfirmModalProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  loading?: boolean
  packageName?: string
}

// VRG-138 Phase 3 (VERA-891): confirms a shipment's label purchase before
// firing useBuyShipmentLabel. This is a MONEY ACTION in real mode (Shopify
// Shipping label purchase) — the copy says so explicitly. Mock mode still
// shows this confirm (for UI/flow parity — see the task's mock/real gating).
export const BuyLabelConfirmModal = (props: BuyLabelConfirmModalProps) => {
  const { open, onClose, onConfirm, loading, packageName } = props

  return (
    <Modal
      title="Buy shipping label"
      open={open}
      onClose={onClose}
      actions={
        <>
          <Button disableElevation variant="secondary" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button disableElevation variant="primary" loading={loading} onClick={onConfirm}>
            Buy label
          </Button>
        </>
      }
    >
      <Stack spacing={4}>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
          {`This purchases a Shopify Shipping label for ${
            packageName ? `"${packageName}"` : 'this shipment'
          } and charges the store's Shopify Shipping balance. This can't be undone.`}
        </Typography>
      </Stack>
    </Modal>
  )
}
